/**
 * Soft cart toast, cart upsell, exit mini offer
 */
(function () {
  const TOAST_MS = 2600;

  function ensureToast() {
    let toast = document.getElementById('hk-cart-toast');
    if (toast) return toast;

    toast = document.createElement('div');
    toast.id = 'hk-cart-toast';
    toast.className = 'hk-cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<span class="hk-cart-toast__check" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
      '</span>' +
      '<span class="hk-cart-toast__text">Sepete eklendi</span>' +
      '<button type="button" class="hk-cart-toast__action">Sepeti aç</button>';

    toast.querySelector('.hk-cart-toast__action').addEventListener('click', () => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      hideToast();
    });

    document.body.appendChild(toast);
    return toast;
  }

  let hideTimer = null;

  function hideToast() {
    const toast = document.getElementById('hk-cart-toast');
    if (!toast) return;
    toast.classList.remove('is-visible');
    if (hideTimer) clearTimeout(hideTimer);
  }

  window.HobikolikToast = {
    show(message) {
      const toast = ensureToast();
      const text = toast.querySelector('.hk-cart-toast__text');
      if (text && message) text.textContent = message;
      toast.classList.add('is-visible');
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(hideToast, TOAST_MS);
    },
    hide: hideToast,
  };

  function getSectionsPayload(cart) {
    if (!cart || typeof cart.getSectionsToRender !== 'function') return [];
    return cart.getSectionsToRender().map((section) => section.id);
  }

  async function addVariantToCart(variantId) {
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = {
      id: Number(variantId),
      quantity: 1,
    };
    if (cart) {
      body.sections = getSectionsPayload(cart);
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (data.status) throw new Error(data.description || data.message || 'Cart error');
    if (cart && typeof cart.renderContents === 'function') {
      cart.renderContents(data);
    }
    if (window.HobikolikToast) window.HobikolikToast.show('2. ürün eklendi');
    return data;
  }

  function bindCartUpsell(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-cart-upsell-add]').forEach((btn) => {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', async () => {
        const variantId = btn.getAttribute('data-variant-id');
        if (!variantId || btn.classList.contains('is-loading')) return;
        btn.classList.add('is-loading');
        btn.setAttribute('disabled', 'disabled');
        const label = btn.querySelector('.cart-drawer__upsell-btn-label');
        const loading = btn.querySelector('.cart-drawer__upsell-btn-loading');
        if (label) label.classList.add('hidden');
        if (loading) loading.classList.remove('hidden');
        try {
          await addVariantToCart(variantId);
        } catch (error) {
          console.error(error);
          btn.removeAttribute('disabled');
          btn.classList.remove('is-loading');
          if (label) label.classList.remove('hidden');
          if (loading) loading.classList.add('hidden');
          if (window.HobikolikToast) window.HobikolikToast.show('Eklenemedi, tekrar dene');
        }
      });
    });
  }

  function initExitMiniOffer() {
    const bar = document.getElementById('hk-exit-mini-offer');
    if (!bar) return;

    const storageKey = 'hk_exit_offer_dismissed';
    if (sessionStorage.getItem(storageKey) === '1') return;

    const delaySec = Number(bar.dataset.delay || 18);
    let shown = false;

    function show() {
      if (shown || sessionStorage.getItem(storageKey) === '1') return;
      shown = true;
      bar.hidden = false;
      requestAnimationFrame(() => bar.classList.add('is-visible'));
    }

    function hide() {
      bar.classList.remove('is-visible');
      sessionStorage.setItem(storageKey, '1');
      setTimeout(() => {
        bar.hidden = true;
      }, 280);
    }

    bar.querySelector('[data-exit-offer-close]')?.addEventListener('click', hide);

    setTimeout(show, Math.max(delaySec, 5) * 1000);

    // Soft exit intent on desktop
    document.addEventListener('mouseout', (event) => {
      if (event.clientY > 12) return;
      if (event.relatedTarget || event.toElement) return;
      show();
    });
  }

  function init() {
    bindCartUpsell(document);
    initExitMiniOffer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    bindCartUpsell(event.target);
  });

  const drawer = document.querySelector('cart-drawer');
  if (drawer && typeof MutationObserver !== 'undefined') {
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        bindCartUpsell(drawer);
      });
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }
})();
